import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {loadWarehouseById} from '../../actions/setting'
import {Breadcrumb} from 'semantic-ui-react'
import _ from 'lodash'
import Dls from '../../lib'
import WarehouseForm from '../forms/settings/Warehouse'

class WarehouseViewPage extends Component {
    //access router
    //this.props.history.push('/dashboard')
    componentDidMount() {
        const {jwt} = this.props;
        const {id} = this.props.match.params;
        this.props.loadWarehouseById(jwt, id);
    }

    render() {
        const {model} = this.props;
        return (
            <div>
                {_.isEmpty(model) ? <div></div> : 
                    <div>
                        <div className="row">
                            <div className="col-md-8">
                                <Breadcrumb size="huge">
                                    <Breadcrumb.Section>
                                        Settings
                                    </Breadcrumb.Section>
                                    <Breadcrumb.Divider />
                                    <Breadcrumb.Section>
                                        <Link
                                            to={`/settings/warehouses/${Dls.pagination.warehouses()}`}
                                        >
                                            Warehouses
                                        </Link>
                                    </Breadcrumb.Section>
                                    <Breadcrumb.Divider />
                                    <Breadcrumb.Section>
                                        {model.id ? model.label : 'Create New Warehouse'}
                                    </Breadcrumb.Section>
                                </Breadcrumb>
                            </div>
                            <div className="col-md-4">

                            </div>
                        </div>
                        <div className="row" style={{marginTop: '10px'}}>
                            <div className="col-md-8">
                            <WarehouseForm
                                history={this.props.history}
                                initialModel={model}
                            />
                            </div>

                        </div>
                    </div>
                }
            </div>
        )
    }
}

WarehouseViewPage.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.object.isRequired
    }),
    loadWarehouseById: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    jwt: PropTypes.string.isRequired
};

function mapStateToProps(state) {
    return {
        model: state.warehouse.model,
        jwt: state.auth.jwt
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        loadWarehouseById
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseViewPage)


// WEBPACK FOOTER //
// ./src/components/settings/WarehouseShow.js